export const breakpointValues = {
  sm: 480,
  md: 600,
  lg: 768,
  xl: 992,
  '2xl': 1280,
};
export const breakpoints = {
  sm: '30rem',
  md: '37.5rem',
  lg: '48rem',
  xl: '62rem',
  '2xl': '80rem',
};
export const breakpointNumbers = {
  sm: 1,
  md: 2,
  lg: 3,
  xl: 4,
  '2xl': 5,
};

export type BreakpointKeys = keyof typeof breakpointValues;
export type Breakpoints<T = number> = Record<BreakpointKeys, T>;
export type ResponsiveBreakpoints<T = number | string> = Partial<
  Breakpoints<T> & {
    base: T;
  }
>;
